module.exports = __webpack_public_path__ + "static/media/creativeops.47ffa984.jpg";